export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const formatDate = (date: Date): string => {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(date);
};

export const formatDateTime = (dateStr?: string) => {
  if (!dateStr) return { date: '', time: '' };

  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return { date: '', time: '' };

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');

  return {
    date: `${day}-${month}-${year}`,
    time: `${hours}:${minutes}`,
  };
};

export const formatWalletDate = (dateStr?: string) => {
  if (!dateStr) return '';

  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = String(d.getFullYear()).slice(-2);

  let hours = d.getHours();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  const minutes = String(d.getMinutes()).padStart(2, '0');

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};

export const getPickupDisplayName = (
  originAddress?: {
    contact_name?: string | null;
    company_name?: string | null;
  } | null
): string => {
  if (!originAddress) return 'Warehouse';
  const contact = originAddress.contact_name?.trim();
  const company = originAddress.company_name?.trim();
  return company || contact || 'Warehouse';
};

export const formatShortDate = (dateStr?: string) => {
  if (!dateStr || dateStr === '-' || dateStr === 'N.A' || dateStr === 'N/A') return dateStr;
  
  const str = dateStr.trim();

  // If format is YYYY-MM-DD
  const isoMatch = str.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (isoMatch) {
    const [, year, month, day] = isoMatch;
    return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year.slice(-2)}`;
  }

  // If format is DD-MM-YYYY
  const dmyMatch = str.match(/^(\d{1,2})-(\d{1,2})-(\d{4})/);
  if (dmyMatch) {
    const [, day, month, year] = dmyMatch;
    return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year.slice(-2)}`;
  }
  
  const d = new Date(str);
  if (isNaN(d.getTime())) return dateStr;
  
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = String(d.getFullYear()).slice(-2);
  
  return `${day}-${month}-${year}`;
};

export const formatTimeSlot = (slot?: string) => {
  if (!slot) return '';
  
  // Format to standard 12-hour AM/PM
  const formatTime = (timeStr: string) => {
    let [hours, minutes = '00'] = timeStr.trim().split(':').map(Number);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    return `${hours}:${String(minutes).padStart(2, '0')} ${ampm}`;
  };

  // Match formats like '10-12', '10 - 12', '10:00-12:00', '10:00 - 12:00'
  const match = slot.match(/^(\d{1,2}(?::\d{2})?)\s*-\s*(\d{1,2}(?::\d{2})?)$/);
  if (match) {
    const start = formatTime(match[1]);
    const end = formatTime(match[2]);
    return `${start} - ${end}`;
  }
  
  return slot;
};

export const formatShortMonthDate = (dateStr?: string) => {
  if (!dateStr) return dateStr;
  const parts = dateStr.split(' ');
  if (parts.length === 3 && parts[1].length > 3) {
    // Expects formats like "10 October 2026"
    return `${parts[0]} ${parts[1].substring(0, 3)} ${parts[2]}`;
  }
  return dateStr;
};

export {};
